module.exports = __webpack_public_path__ + "static/media/Releated2.534069f4.png";